export const Languages = [
  {
    code: "hr",
    abbr: "HRV",
    title: "Hrvatski"
  },
  {
    code: "en",
    abbr: "ENG",
    title: "English"
  }
];